export const TEXT_LENGTH_ERROR =
  'Необходимо ввести результат, не менее 2, но не более 5000 символов';
